import styled from "styled-components/macro";
import {theme} from "../../../../styles/theme";

export const Wrapper = styled.div`
  background: ${theme.colors.bgSecondary};
  & > div {
    margin: 0 auto;
    max-width: 1380px;
    padding: 46px 120px;
    display: flex;
    justify-content: space-between;
    color: ${theme.colors.text};
    @media (max-width: 930px) {
      padding: 46px 40px;
    }
    @media (max-width: 850px) {
      padding: 46px 20px;
    }
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

`;

export const Content = styled.div`
  max-width: 430px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-right: 20px;
  & > div {
    font-size: 32px;
    margin-bottom: 32px;
  }
  & > p {
    font-size: 24px;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    & > div {
      font-size: 24px;
      margin-bottom: 18px;
    }
    & > p {
      font-size: 20px;
    }
  }
`;

export const FormSection = styled.div`
  max-width: 450px;
  min-width: 360px;
  width: 100%;
  background: white;
  padding: 24px;
  border-radius: 6px;
  & span {
    display: block;
    margin: 0 auto 10px auto;
    color: red;
  }
  & > div {
    display: flex;
    flex-direction: column;
    & label {
      font-size: 18px;
      display: flex;
      flex-direction: column;
      & span {
        color: red;
        font-size: 14px;
        margin: -14px 0 0 0;
        padding-left: 4px;
      }
    }
  }
  & button[disabled] {
    opacity: 60%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;
    background: transparent;
    min-width: 100px;
  }
`;
export const FormTitle = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    display: none !important;
  }
`;

export const Input = styled.input<{error: boolean}>`
  border-radius: 6px;
  padding: 9px 16px;
  border: 1px solid ${(({error}) => error ? 'red' : theme.colors.border)};
  color: ${theme.colors.textDimmed};
  margin-bottom: 16px;
`;